(function () {
    "use strict";

    angular.module("app").filter("utcLocalAdd", Filter);

    function Filter() {
        return (input) => {
            if (angular.isObject(input)) {
                //get the user timezone offset.
                const offset = -moment(input).utcOffset();

                //Convert to UTC time first, then add offset
                const utc = moment(input).utc();

                return moment(utc.utcOffset(offset * -1)).toDate();
            }
        };
    }
})();
